import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';

@Component({
    selector: 'not-found',
    template: require('./not-found.component.html'),
    styles: [require('./not-found.component.css')],
    animations: [fadeInOut]
})
export class NotFoundComponent {
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/not-found/not-found.component.ts